import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Link } from 'react-router-dom';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import logo from '../../../../Assets/images/Airswift Primary Logo (Black Text).png';
import FileFolderEditIcon from '../../../common/Icons/FileFolderEditIcon';
import { TimeExpenseIcon } from '../../../common/Icons';
import CookieButton from '../../../hubspotButton/CookieButton';
import classes from './SidePanel.module.scss';
import BottomLinks from '../../../common/BottomLinks/BottomLinks';

function SideLink({ url, icon, label, click }) {
  return (
    <li role="presentation" className={classes.link} onClick={click}>
      <Link to={url}>
        {icon}
        <span className={classes.label}>{label.toUpperCase()}</span>
      </Link>
    </li>
  );
}

export default function SidePanel({ isOpen, onClose }) {
  const [t] = useTranslation();

  const accessTo = useSelector((state) => state.accessToParts);

  return (
    <SwipeableDrawer
      anchor="left"
      open={isOpen}
      onClose={onClose}
      onOpen={() => {}}
      sx={{
        '& .MuiPaper-root.MuiDrawer-paper': {
          width: '219px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '26px 0 81px 0'
        }
      }}
    >
      <Link to="/dashboard" onClick={onClose}>
        <img alt="logo" src={logo} width="153px" height="65px" />
      </Link>
      <ul className={classes.linkList}>
        {!accessTo.tAndEApprover && (
          <SideLink url="/dashboard/Jobs" icon={<WorkOutlineIcon />} label={t('dashboard.jobs.job')} click={onClose} />
        )}
        {accessTo.onboarding && (
          <SideLink
            url="/dashboard/tifo"
            icon={<FileFolderEditIcon />}
            label={t('common.header.menu.onboarding')}
            click={onClose}
          />
        )}
        {(accessTo.tAndEContractor || accessTo.tAndEApprover) && (
          <>
            <SideLink
              url="/dashboard/timesheets"
              icon={<TimeExpenseIcon />}
              label={t('dashboard.timesheets.sidetabTime')}
              click={onClose}
            />
            <SideLink
              url="/dashboard/expenses"
              icon={<AttachMoneyIcon />}
              label={t('dashboard.expenses.sidetabExpense')}
              click={onClose}
            />
          </>
        )}
      </ul>
      <div role="presentation" className={classes.bottomLinks} onClick={onClose}>
        <CookieButton />
        <div className={classes.secondLine}>
          <BottomLinks
            url="https://app.airswift.com/dashboard?cmpscreencustom"
            label={t('common.footer.privacy').toUpperCase()}
          />
          <div className={classes.dot} />
          <BottomLinks url="https://www.airswift.com/" label="AIRSWIFT ©" />
        </div>
      </div>
    </SwipeableDrawer>
  );
}
